module.exports = {
    APPLICATION_ID: 'BdSYShHyLMSauwh6WfzaQ63roeNubaor3FSYinGE',
    JAVASCRIPT_KEY: 'QYFb4wPkwnIQ0zrE0TZLSvVH1TqtNFfeFHhTun5J',
    SERVER_URL: 'https://parseapi.back4app.com'
};